<template minapp='mpx' xlang='wxml'>
  <es-popup position="bottom" closeable="{{false}}" show="{{visible}}">
    <view class="es-privacy">
      <view class="es-privacy__header">
        {{ list.title }}
      </view>
      <view class="es-privacy__body">
        {{ list.content }}
      </view>
      <view class="es-privacy__link">
        <view bindtap="onLink">
          {{ list.link_text }}
        </view>
      </view>
      <view class="es-privacy__footer">
        <view class="es-privacy__button es-privacy__button--disagree" bindtap="onCancel">
          {{ list.disagree_btn_text }}
        </view>
        <view class="es-privacy__button es-privacy__button--primary" bindtap="onConfirm">
          {{ list.agree_btn_text }}
        </view>
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { postSign } from './api'
  import { xenv, goTo, is } from '@didi/webx-js'
  import { getStorage } from '@/utils/storage'
  createComponent({
    props: {
      list: {
        type: Object,
        value: {}
      },
      scene: { // 百川配置的业务场景
        type: String,
        value: 'customer_train'
      },
      caller: { // 前端调用接口时自定义的独特id
        type: String,
        value: 'customer_train_toc'
      }
    },
    data: {
      visible: true,
    },
    computed: {
      appId() {
        const appidMap = {
          alimp: 35023,
          wxmp: 35009,
          passenger: 10000,
          h5: 10000
        }
        return appidMap[xenv()]
      },
      token() {
        return getStorage('token') || getStorage('userInfo')?.token
      }
    },
    methods: {
      onLink() {
        const { link_url } = this.list
        // 端上需要用goTo打开一个新webview，展示title bar
        // 小程序使用goTo会带一些和百川冲突的参数，且没有title bar问题，所以直接用location.href打开
        if(is('passenger')) {
          goTo({ url: decodeURIComponent(link_url) })
        } else {
          window.location.href = decodeURIComponent(link_url)
        }
      },
      onCancel() {
        this.$trigger('privacyVerify', false)
      },
      onConfirm() {
        this.postSign()
      },
      async postSign() {
        // 签署协议
        const params = {
          appid: this.appId,
          token: this.token,
          doc_id: this.list.doc_id,
          scene: this.scene,
          caller: this.caller
        }
        try {
          const { errno, errmsg } = await postSign(params)
          if (+errno !== 0) {
            mpx.showToast({
              title: errmsg,
              icon: 'none'
            })
            return
          }
          this.$trigger('privacyVerify', true)
        } catch (error) {
          console.error('222', error)
        }
      }
    },
  })
</script>

<style scoped>
  .es-privacy {
    border-radius: 16px 16px 0 0;
    padding: 0 20px;
    background: #ffffff;
    overflow: hidden;
    box-sizing: border-box;
  }
  .es-privacy__header {
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #000;
    padding: 32px 0 10px 0;
  }
  .es-privacy__body {
    max-height: 120px;
    overflow-y: auto;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
  }
  .es-privacy__link {
    margin: 18px 0;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #1473ff;
    text-align: center;
    text-decoration: underline;
  }
  .es-privacy__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 100rpx;
  }
  .es-privacy__button {
    flex: 1;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    text-align: center;
    font-size: 16px;
    box-sizing: border-box;
  }

  .es-privacy__button--disagree {
    border: 1px solid #ccc;
    color: #333;
  }

  .es-privacy__button--primary {
    margin-left: 16rpx;
    border: 1px solid #FF6400;
    background: #FF6400;
    color: #fff;
  }
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-popup': '@didi/es-mpx-ui/lib/popup'
    }
  }
</script>

